<template>
  <b-card
      title="گزارش ادتریس"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="موبایل"
                    label-for="Mobile"
                >
                  <b-form-input
                      v-model="filterOptions.Mobile"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="شناسه کاربر"
                    label-for="UserId"
                >
                  <b-form-input
                      v-model="filterOptions.UserId"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="کمپین"
                    label-for="Campaign"
                    class="d-inline-block full-width"
                >
                  <campaign-select v-model="filterOptions.AdsCampaignId" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="کانال تبلیغاتی"
                    label-for="Channel"
                    class="d-inline-block full-width"
                >
                  <channel-select v-model="filterOptions.AdsChannelId" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      clearable
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Name)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.item.UserId }}">
              <span class="text-nowrap d-block" style="color: #6e6b7b;">
                {{ data.item.Name }} {{ data.item.Family }}
              </span>
              <small class="text-muted">{{ `#${data.item.UserId}` }}</small>
            </b-link>
          </template>

          <template #cell(AdsAttribution)="data">
            {{ (attributions.find(a => a.Id === data.value) || {}).Title }}
          </template>

          <template #cell(CreateAt)="data">
            {{ data.value | date }}
          </template>

          <template #cell(RegisterAt)="data">
            {{ data.value | date }}
          </template>

          <template #cell(SumPayment)="data">
            {{ data.value | price }}
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import CampaignSelect from "@/tools/campaign.vue";
import ChannelSelect from "@/tools/channel.vue";
export default {
  name: 'MatrixReport',
  components: { CampaignSelect, ChannelSelect },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Page: 1,
        FromDate: null,
        ToDate: null,
        Mobile: null,
        UserId: null,
        AdsCampaignId: null,
        AdsChannelId: null,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Name',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'CreateAt',
          label: 'تاریخ',
        },
        {
          key: 'RegisterAt',
          label: "تاریخ ثبت نام",
        },
        {
          key: 'InstallStatus',
          label: 'وضعیت نصب',
        },
        {
          key: 'SumPayment',
          label: 'کل پرداخت',
        },
        {
          key: 'TrackerName',
          label: 'Tracker Name',
        },
        {
          key: 'TrackerToken',
          label: 'Tracker Token',
        },
        {
          key: 'Network',
          label: 'Network',
        },
        {
          key: 'Campaign',
          label: 'Campaign',
        },
        {
          key: 'Adgroup',
          label: 'Adgroup',
        },
        {
          key: 'Creative',
          label: 'Creative',
        },
        {
          key: 'ClickLabel',
          label: 'Click Label',
        },
        {
          key: 'Adid',
          label: 'Adid',
        },
        {
          key: 'CostType',
          label: 'Cost Type',
        },
        {
          key: 'CostAmount',
          label: 'Cost Amount',
        },
        {
          key: 'CostCurrency',
          label: 'Cost Currency',
        },
      ],
      items: []
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.attributions.adtraceReport, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>